import dayjs from './dates';

/** Initiales d'un nom de moniteur (« Kenza B. » → « KB »). */
export function monitorInitials(name: string | null | undefined): string {
  if (!name) return '··';
  const parts = name
    .replace(/\./g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2);
  if (parts.length === 0) return '··';
  return parts.map((p) => p.charAt(0).toUpperCase()).join('');
}

/** Durée d'un créneau en heures, arrondie à la demi-heure. */
export function durationLabel(startsAt: string, endsAt: string): string {
  const minutes = dayjs(endsAt).diff(dayjs(startsAt), 'minute');
  if (minutes <= 0) return '';
  const hours = minutes / 60;
  const rounded = Math.round(hours * 2) / 2;
  return Number.isInteger(rounded) ? `${rounded}h` : `${rounded}h`;
}

/** « Lun 13 Jan · 16:00 – 17:00 » */
export function slotLabel(startsAt: string, endsAt: string): string {
  const start = dayjs(startsAt);
  const day = start.format('ddd D MMM');
  const capDay = day.charAt(0).toUpperCase() + day.slice(1);
  return `${capDay} · ${start.format('HH:mm')} – ${dayjs(endsAt).format('HH:mm')}`;
}

/** Position d'un créneau dans la grille calendrier (colonne jour, ligne 30 min). */
export const CAL_START_HOUR = 8;
export const CAL_END_HOUR = 20;

export function gridPosition(
  startsAt: string,
  endsAt: string,
): { col: number; row: number; span: number } {
  const start = dayjs(startsAt);
  // Colonne : Lundi = 2 … Dimanche = 8 (colonne 1 = libellés horaires).
  const col = ((start.day() + 6) % 7) + 2;
  const minutesFromStart =
    (start.hour() - CAL_START_HOUR) * 60 + start.minute();
  const row = Math.max(0, Math.floor(minutesFromStart / 30)) + 1;
  const durationMin = Math.max(30, dayjs(endsAt).diff(start, 'minute'));
  const span = Math.max(1, Math.round(durationMin / 30));
  return { col, row, span };
}

const euro = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
});

export function formatEuro(amount: number): string {
  return euro.format(amount);
}

/** Libellé + classes de badge pour un statut de facture / contrat. */
export function statusBadge(status: string): { label: string; className: string } {
  const map: Record<string, { label: string; className: string }> = {
    paid: { label: 'Payée', className: 'bg-green-50 text-green-700 border-green-200' },
    sent: { label: 'Envoyée', className: 'bg-indigo-50 text-indigo-700 border-indigo-200' },
    unpaid: { label: 'À payer', className: 'bg-amber-50 text-amber-700 border-amber-200' },
    cancelled: { label: 'Annulée', className: 'bg-slate-100 text-slate-500 border-slate-200' },
    signed: { label: 'Signé', className: 'bg-green-50 text-green-700 border-green-200' },
    pending_signature: {
      label: 'À signer',
      className: 'bg-amber-50 text-amber-700 border-amber-200',
    },
  };
  return (
    map[status] ?? {
      label: status,
      className: 'bg-slate-100 text-slate-600 border-slate-200',
    }
  );
}
